/* Nakylo : animations des sections d'accueil (nky-*). Chargé en defer depuis layout/theme.liquid.
   Chaque partie ne s'active que si sa section est là ; l'éditeur de thème relance la section rechargée.
   - mot du hero : tourne toutes les 2,6 s et recolore :root (--pa, --pa-rgb, --pa-on, --pa-ink, --pa-soft, --pa-hi)
   - révélation au défilement : classe « vu » (+ filet de sécurité à 1,8 s)
   - parallaxe des plateaux (appareils avec survol)
   - manifeste : les mots s'allument en passant la ligne des 62 % de l'écran
   - problèmes → solutions : un appui ouvre la solution (accordéon sur mobile, panneau à droite sur ordinateur)
   prefers-reduced-motion : pas de rotation, tout visible. */
(function () {
  'use strict';

  var html = document.documentElement;
  html.classList.add('nky-js');

  function media(q) { return !!(window.matchMedia && window.matchMedia(q).matches); }
  var reduit = media('(prefers-reduced-motion: reduce)');
  var survol = media('(hover: hover)');
  function tous(racine, sel) { return Array.prototype.slice.call(racine.querySelectorAll(sel)); }

  /* ---------- couleurs d'accent (mêmes règles que snippets/nky-accent.liquid) ---------- */
  var PAPIER = [251, 249, 245], ENCRE = [27, 21, 16];

  function hexVersRgb(hex) {
    var h = String(hex || '').trim().replace('#', '');
    if (h.length === 3) h = h.replace(/./g, '$&$&');
    if (!/^[0-9a-f]{6}$/i.test(h)) return null;
    var n = parseInt(h, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function rgbVersHex(c) {
    return '#' + c.map(function (v) { return ('0' + Math.round(v).toString(16)).slice(-2); }).join('').toUpperCase();
  }
  function luminance(c) {
    var l = c.map(function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
    return 0.2126 * l[0] + 0.7152 * l[1] + 0.0722 * l[2];
  }
  function contraste(a, b) {
    var x = luminance(a), y = luminance(b);
    return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05);
  }
  function versTsl(c) {
    var r = c[0] / 255, g = c[1] / 255, b = c[2] / 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min;
    var h = 0, s = 0, l = (max + min) / 2;
    if (d) {
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
      else if (max === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h /= 6;
    }
    return [h, s, l];
  }
  function depuisTsl(h, s, l) {
    if (!s) return [l * 255, l * 255, l * 255];
    function canal(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    }
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s, p = 2 * l - q;
    return [canal(p, q, h + 1 / 3) * 255, canal(p, q, h) * 255, canal(p, q, h - 1 / 3) * 255];
  }
  /* décale la luminosité TSL de « points » absolus, comme color_darken / color_lighten */
  function decaler(c, points) {
    var t = versTsl(c);
    return depuisTsl(t[0], t[1], Math.min(1, Math.max(0, t[2] + points / 100))).map(Math.round);
  }

  var cache = {};
  function accentDe(hex) {
    if (cache[hex]) return cache[hex];
    var c = hexVersRgb(hex);
    if (!c) return null;
    var p, ink = c, hi = c;
    for (p = 1; p <= 60 && contraste(ink, PAPIER) < 4.5; p++) ink = decaler(c, -p);
    for (p = 1; p <= 80 && contraste(hi, ENCRE) < 4.5; p++) hi = decaler(c, p);
    var soft = c.map(function (v, i) { return v * 0.14 + PAPIER[i] * 0.86; });
    cache[hex] = {
      '--pa': rgbVersHex(c),
      '--pa-rgb': c.join(','),
      '--pa-on': contraste(c, ENCRE) >= contraste(c, PAPIER) ? '#1B1510' : '#FBF9F5',
      '--pa-ink': rgbVersHex(ink),
      '--pa-soft': rgbVersHex(soft),
      '--pa-hi': rgbVersHex(hi),
      '--pa-hover': rgbVersHex(decaler(hi, -6))
    };
    return cache[hex];
  }
  function appliquer(hex) {
    var v = accentDe(hex);
    if (!v) return;
    for (var k in v) html.style.setProperty(k, v[k]);
  }

  /* ---------- mot qui tourne ---------- */
  function initRot(rot) {
    if (rot._nky) return;
    rot._nky = true;
    var mots = tous(rot, 'b');
    if (!mots.length) return;
    var idx = 0;
    mots.forEach(function (b, i) { if (b.classList.contains('on')) idx = i; });
    appliquer(mots[idx].getAttribute('data-pa'));
    if (reduit || mots.length < 2) return;

    function montrer(i) {
      if (i === idx) return;
      var prec = mots[idx];
      idx = i;
      prec.classList.remove('on');
      prec.classList.add('out');
      setTimeout(function () { prec.classList.remove('out'); }, 600);
      mots[idx].classList.add('on');
      appliquer(mots[idx].getAttribute('data-pa'));
    }
    /* éditeur : sélectionner un bloc « mot » l'affiche et met la rotation en pause */
    rot._nkyChoisir = function (b) {
      var i = mots.indexOf(b);
      if (i < 0) return;
      rot._nkyPause = true;
      montrer(i);
    };
    rot._nkyTimer = setInterval(function () {
      if (!rot.isConnected) { clearInterval(rot._nkyTimer); return; }
      if (rot._nkyPause || document.hidden) return;
      montrer((idx + 1) % mots.length);
    }, 2600);
  }

  /* ---------- parallaxe des plateaux ---------- */
  function initVitrine(v) {
    if (v._nky || reduit || !survol) return;
    v._nky = true;
    var plateaux = tous(v, '.nky-plateau');
    var x = 0, y = 0, image = 0;
    function poser() {
      image = 0;
      plateaux.forEach(function (p) {
        var d = parseFloat(p.getAttribute('data-depth')) || 1;
        p.style.transform = 'translate(' + (x * 14 * d).toFixed(1) + 'px,' + (y * 10 * d).toFixed(1) + 'px)';
      });
    }
    v.addEventListener('mousemove', function (e) {
      var r = v.getBoundingClientRect();
      x = (e.clientX - r.left) / r.width - 0.5;
      y = (e.clientY - r.top) / r.height - 0.5;
      if (!image) image = requestAnimationFrame(poser);
    });
    v.addEventListener('mouseleave', function () {
      if (image) { cancelAnimationFrame(image); image = 0; }
      plateaux.forEach(function (p) { p.style.transform = ''; });
    });
  }

  /* ---------- manifeste : découpe en mots, le gras reste un seul bloc ---------- */
  var motsManif = [], demande = 0;
  var BLOC = /^(STRONG|B|MARK)$/;
  function decouper(el) {
    Array.prototype.slice.call(el.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        if (!n.nodeValue.trim()) return;
        var frag = document.createDocumentFragment();
        /* espaces ordinaires seulement : l'insécable reste collé au mot (« mode : ») */
        n.nodeValue.split(/([ \t\r\n]+)/).forEach(function (m) {
          if (!m) return;
          if (/^[ \t\r\n]+$/.test(m)) { frag.appendChild(document.createTextNode(m)); return; }
          var s = document.createElement('span');
          s.className = 'nky-w';
          s.textContent = m;
          frag.appendChild(s);
        });
        el.replaceChild(frag, n);
      } else if (n.nodeType === 1) {
        if (BLOC.test(n.tagName)) n.classList.add('nky-w');
        else decouper(n);
      }
    });
  }
  function allumer() {
    demande = 0;
    var ligne = window.innerHeight * 0.62;
    motsManif.forEach(function (w) { w.classList.toggle('on', w.getBoundingClientRect().top < ligne); });
  }
  function demander() { if (!demande && motsManif.length) demande = requestAnimationFrame(allumer); }
  function initManif(c) {
    if (c._nky) return;
    c._nky = true;
    decouper(c);
    var ws = tous(c, '.nky-w');
    if (reduit) { ws.forEach(function (w) { w.classList.add('on'); }); return; }
    motsManif = motsManif.filter(function (w) { return w.isConnected; }).concat(ws);
    allumer();
  }
  if (!reduit) {
    window.addEventListener('scroll', demander, { passive: true });
    window.addEventListener('resize', demander);
  }

  /* ---------- révélation au défilement ---------- */
  function initRevelation(racine) {
    var els = tous(racine, '.nky .nky-rv, .nky .nky-plateau').filter(function (el) { return !el.classList.contains('vu'); });
    if (!els.length) return;
    if (reduit || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vu'); });
      return;
    }
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vu'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      els.forEach(function (el) { el.classList.add('vu'); });
      io.disconnect();
    }, 1800);
  }

  /* ---------- problèmes → solutions ---------- */
  var large = window.matchMedia ? window.matchMedia('(min-width: 900px)') : null;
  function initSolutions(grille) {
    if (grille._nkySol) return;
    grille._nkySol = true;
    var items = tous(grille, '.nky-sol-item');
    function basculer(item, on) {
      item.classList.toggle('on', on);
      var b = item.querySelector('.nky-sol-q button');
      if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    function choisir(item) { items.forEach(function (it) { basculer(it, it === item); }); }
    items.forEach(function (item) {
      var b = item.querySelector('.nky-sol-q button');
      if (!b) return;
      b.addEventListener('click', function () {
        var grand = large && large.matches;
        // mobile : un second appui referme ; ordinateur : une solution reste toujours affichée
        if (item.classList.contains('on') && !grand) { basculer(item, false); return; }
        choisir(item);
        // mobile : le panneau d'au-dessus s'est refermé, la question a pu remonter hors de l'écran
        if (!grand && b.getBoundingClientRect().top < 0) b.parentNode.scrollIntoView({ block: 'start', behavior: reduit ? 'auto' : 'smooth' });
      });
    });
    // retour en grand écran avec tout replié : on rouvre le premier
    if (large && large.addEventListener) large.addEventListener('change', function (e) {
      if (e.matches && !grille.querySelector('.nky-sol-item.on') && items[0]) choisir(items[0]);
    });
    grille._nkyChoisir = choisir; // éditeur : sélectionner un bloc ouvre sa solution
  }

  function init(racine) {
    racine = racine || document;
    tous(racine, '[data-nky-rot]').forEach(initRot);
    tous(racine, '[data-nky-vitrine]').forEach(initVitrine);
    tous(racine, '[data-nky-manif]').forEach(initManif);
    tous(racine, '[data-nky-sol]').forEach(initSolutions);
    initRevelation(racine);
  }

  init(document);

  /* ---------- éditeur de thème ---------- */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    tous(e.target, '[data-nky-rot]').forEach(function (r) { clearInterval(r._nkyTimer); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var rot = e.target && e.target.parentNode;
    if (rot && rot._nkyChoisir) rot._nkyChoisir(e.target);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var rot = e.target && e.target.parentNode;
    if (rot && rot._nkyChoisir) rot._nkyPause = false;
  });
})();

/* Vidéos « lecture auto » des blocs Nakylo (classe nky-b-video--auto, sans attribut autoplay pour ne pas tout
   télécharger à l'ouverture) : lancées sans le son quand elles approchent de l'écran. Si le navigateur refuse
   (iPhone en économie d'énergie), on montre les commandes. */
(function () {
  'use strict';
  function lancer(v) {
    if (!v.paused) return;
    v.muted = true;
    var essai = v.play();
    if (essai && essai.catch) essai.catch(function (e) { if (e && e.name === 'NotAllowedError') v.setAttribute('controls', ''); });
  }
  var guetteur = 'IntersectionObserver' in window ? new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) { if (e.isIntersecting) { guetteur.unobserve(e.target); lancer(e.target); } });
  }, { rootMargin: '200px 0px' }) : null;
  function brancher() {
    document.querySelectorAll('video.nky-b-video--auto:not([data-nky-proche])').forEach(function (v) {
      v.setAttribute('data-nky-proche', '1');
      if (guetteur) guetteur.observe(v); else lancer(v);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher); else brancher();
  document.addEventListener('shopify:section:load', brancher);
})();
